export const restLayer = {
  data() {
    return {
      layer: {
        desc: '',
        geoserver_data: {
          filename: '',
          coordinatessystem: 'EPSG:3857',
          workspace: '',
          datastore: ''
        },
        id_category: '-1',
        geometry_type: '',
        fecha_dato: null,
        fecha_actualizacion: null,
        name: '',
        provider: {
          name: '',
          url: '',
          parsedurl: [],
          geoserverdata: {
            filename: '',
            coordinatessystem: 'EPSG:3857',
            workspace: '',
            datastore: '',
            maxfeatures: '',
            outputformat: '',
            request: '',
            service: '',
            version: ''
          }
        }
      },
      layers: [],
    }
  },
  methods: {
    getLayer: function () {
      const that = this;
      this.$http.get(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer)
        .then(function (response) {
          that.layer = response.data;
          console.log('get Layer', that.layer);
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    getLayersPages(page, search = '', sortKey = '', sortOrder = 'asc', size = 10, status = 'todos') {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page, size })
      if (search) params.set('search', search)
      if (sortKey) params.set('sort', sortKey)
      params.set('order', sortOrder)
      if (status !== 'todos') params.set('status', status)

      return this.$http.get(`${backendurl}api/v1/layers?${params.toString()}`)
        .then((response) => {
          this.layers = response.data || []
          this.totalPages = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
        .catch((error) => {
          console.log(error)
          this.message = error.response.data.message
        })
    },
    getLayersByCategory(page, idCategory, search = '', sortKey = '', sortOrder = 'asc', size = 10, status = 'todos') {
      const backendurl = this.$store.getters.backendurl
      const params = new URLSearchParams({ page, size })
      if (search) params.set('search', search)
      if (sortKey) params.set('sort', sortKey)
      params.set('order', sortOrder)
      if (status !== 'todos') params.set('status', status)

      return this.$http.get(`${backendurl}api/v1/categories/${idCategory}/layers?${params.toString()}`)
        .then((response) => {
          this.layers = response.data || []
          this.totalPages = response.headers.totalpages === undefined
            ? 0
            : parseInt(response.headers.totalpages, 10)
        })
    },
    getLayersNoPages: function () {
      const that = this;
      return this.$http.get(this.$store.getters.backendurl + 'api/v1/layers/')
        .then(function (response) {
          that.layers = response.data;
          return response.data;
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    getLayersForOrder: function (idCategory, excludeId = '') {
      const params = new URLSearchParams()
      if (excludeId) params.set('exclude_id', excludeId)
      const query = params.toString() ? `?${params.toString()}` : ''
      return this.$http
        .get(`${this.$store.getters.backendurl}api/v1/layers/order/${idCategory}${query}`)
        .then(response => response.data || [])
    },
    putLayersOrder: function (idCategory, layerIds) {
      return this.$http.put(
        `${this.$store.getters.backendurl}api/v1/layers/order/${idCategory}`,
        { layer_ids: layerIds }
      )
    },
    // Mensaje de resultado de las operaciones de capa. Antes `putLayer` guardaba en silencio:
    // sin aviso ni navegación, la única forma de saber si había pasado algo era recargar.
    notifyLayerResult: function (message, type) {
      this.$store.dispatch('toast/show', { message: message, type: type || 'success' })
    },
    layerErrorMessage: function (error) {
      // `error.response` no existe si la petición ni siquiera salió (backend caído, CORS).
      const data = error && error.response && error.response.data
      return (data && (data.message || data.error)) || 'No fue posible completar la operación.'
    },
    postLayer: function () {
      console.log("[restLayer] Se va a enviar al backend la capa:", this.layer);
      const that = this;
      return this.$http.post(this.$store.getters.backendurl + 'api/v1/layers',
        this.layer
      )
        .then(function (response) {
          that.notifyLayerResult('Capa creada.')
          //Obtener ID de la tarea recién creada y pasar a la vista de asignar usuarios
          let idLayer = response.data.id
          that.$router.push('/capas/' + idLayer + '/asignar-mapas')
        })
        .catch(function (error) {
          console.log("Error", error);
          that.notifyLayerResult(that.layerErrorMessage(error), 'error')
        });
    },
    putLayerStatus: function (status) {
      const backendurl = this.$store.getters.backendurl
      return this.$http.put(`${backendurl}api/v1/layers/${this.$route.params.idLayer}/status`, { status })
    },
    putLayer: function () {
      console.log("[restLayer] Actualizar: Se va a enviar al backend la capa:", this.layer);
      const that = this;
      return this.$http.put(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer,
        this.layer
      )
        .then(function (response) {
          that.notifyLayerResult('Cambios guardados.')
          that.$router.push('/capas/' + that.$route.params.idLayer)
        })
        .catch(function (error) {
          console.log(error)
          that.notifyLayerResult(that.layerErrorMessage(error), 'error')
        });
    },
    putLayerArcgis: function (data) {
      const that = this;
      console.log("[restLayerArcgis] Actualizar: Se va a enviar al backend la capa:", data);
      return this.$http.put(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer,
        data
      )
        .then(function (response) {
          that.notifyLayerResult('Cambios guardados.')
          that.$router.push('/capas/' + that.$route.params.idLayer)
        })
        .catch(function (error) {
          console.log(error)
          that.notifyLayerResult(that.layerErrorMessage(error), 'error')
        });
    },
    deleteLayer: function () {
      const that = this;
      this.$http.delete(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer)
        .then(function (response) {
          that.$router.push('/capas')
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    postLayerArcgis: function (data) {
      const that = this;
      console.log("[restLayerArcgis] Se va a enviar al backend la capa:", data);
      const url = this.$store.getters.backendurl + 'api/v1/layers/arcgis'
      return this.$http.post(url, data)
        .then(function (response) {
          console.log("[restLayerArcgis] Capa guardada exitosamente:", response.data);
          that.notifyLayerResult('Capa creada.')
          let idLayer = response.data.id
          that.$router.push('/capas/' + idLayer + '/asignar-mapas')
        })
        .catch(function (error) {
          console.log("[restLayerArcgis] Error al guardar la capa:", error);
          that.notifyLayerResult(that.layerErrorMessage(error), 'error')
        });
    },
  }
}
